import { Department } from '@/domain/Department'
import axios from 'axios'

/**
 * 部門サービス
 */
export default class DepartmentsService {
    /** インスタンス */
    private static _instance: DepartmentsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new DepartmentsService();
        }
        return this._instance;
    }
    
    /**
     * 新規作成
     */
    public async createNew(): Promise<Department> {
        return await axios.get("/api/department/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<Department> {
        return await axios.get(`/api/department/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: Department): Promise<Department> {
        return await axios.post("/api/department/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Department): Promise<Department> {
        return await axios.put(`/api/department/edit/${dto.code}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 部門一覧を検索
     */
    public async findAll(): Promise<Department[]> {
        return await axios.get("/api/departments")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Department[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Department {
        const department = data as Department
        return new Department({ ...department })
    }
}
